"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskItem = void 0;
const react_1 = __importDefault(require("react"));
const Chip_1 = require("@amzn/atoz-web/Chip");
const Row_1 = require("@amzn/atoz-web/Row");
const Text_1 = require("@amzn/atoz-web/Text");
const View_1 = require("@amzn/atoz-web/View");
const Col_1 = require("@amzn/atoz-web/Col");
const TaskItem = ({ chipText, chipBgColor, renderChipIcon, title, subTitle, note, ariaLabel, renderRequestApprovalButton, renderIconButton }) => (react_1.default.createElement(Row_1.Row, { dataTestId: "TaskItem", "aria-label": ariaLabel },
    react_1.default.createElement(Col_1.Col, { flex: 1 },
        react_1.default.createElement(View_1.View, { margin: { bottom: 'S200' } },
            react_1.default.createElement(Chip_1.Chip, { backgroundColor: Chip_1.ChipBackgroundColor[chipBgColor] || chipBgColor, icon: renderChipIcon === null || renderChipIcon === void 0 ? void 0 : renderChipIcon() }, chipText)),
        react_1.default.createElement(Text_1.Text, { fontSize: "T200", fontWeight: "bold", color: "neutral90" }, title),
        react_1.default.createElement(Text_1.Text, { fontSize: "T200", color: "neutral70" }, subTitle),
        note && (react_1.default.createElement(Text_1.Text, { fontSize: "T200", color: "neutral70" },
            react_1.default.createElement("em", null, note)))),
    react_1.default.createElement(Col_1.Col, { justifyContent: "center" }, renderRequestApprovalButton === null || renderRequestApprovalButton === void 0 ? void 0 : renderRequestApprovalButton()),
    react_1.default.createElement(Col_1.Col, { justifyContent: "center" }, renderIconButton === null || renderIconButton === void 0 ? void 0 : renderIconButton())));
exports.TaskItem = TaskItem;
